import type { View } from '../state/store';

/** プラットフォーム向けの画面。player / settings（エミュ設定）はナビ外。 */
export type HubView = Exclude<View, 'player' | 'settings'>;

export interface NavItem {
  id: HubView;
  label: string;
  /** ショートラベル（ボトムナビ） */
  short: string;
  /** ボトムナビに出すか（Platform は PC のみ） */
  bottom: boolean;
}

export const HUB_NAV: NavItem[] = [
  { id: 'home', label: 'Home', short: 'Home', bottom: true },
  { id: 'library', label: 'Retro', short: 'Retro', bottom: true },
  { id: 'games', label: 'Games', short: 'Games', bottom: true },
  { id: 'platform', label: 'Platform', short: 'Platform', bottom: false },
  { id: 'my', label: 'My', short: 'My', bottom: true },
];

export function isHubView(view: View): view is HubView {
  return view !== 'player' && view !== 'settings';
}
